export interface LinkMetadata {
  title?: string;
  description?: string;
  image?: string;
  author?: string;
  publisher?: string;
  date?: string;
  url?: string;
}

export const fetchLinkMetadata = async (url: string): Promise<LinkMetadata> => {
  try {
    const response = await fetch(`https://api.microlink.io/?url=${encodeURIComponent(url)}`);
    const data = await response.json();
    
    if (data.status === 'success') {
      return {
        title: data.data.title,
        description: data.data.description,
        image: data.data.image?.url,
        author: data.data.author,
        publisher: data.data.publisher,
        date: data.data.date,
        url: data.data.url
      };
    }
    return {};
  } catch (error) {
    console.error('Error fetching metadata:', error);
    return {};
  }
};
